<template>
  <UISpin v-if="!store.getProductListAPIProcessed" class="loader-container" size="large" />
  <div
    v-if="store.getProductListAPIProcessed && store.addedProductList.length < 1"
    class="product-container"
  >
    <div class="add-product-image">
      <ProductIcon class="edit-template-image" />
    </div>
    <div class="noproduct-text-container">
      <UITextSmMedium class="font-sans !font-[600] text-gray-900">{{
        t("common.payment.product.addOrSelectProducts")
      }}</UITextSmMedium>
      <UITextSmMedium
        class="font-sans text-sm !font-[400] not-italic leading-5 tracking-normal text-[#475467]"
        >{{ t("common.payment.product.onceYouAddProductsTheyWillShowUpRightHere") }}
      </UITextSmMedium>
    </div>

    <UIButton
      id="add-products-button"
      class="rounded-[4px] px-[10px] py-[6px]"
      @click="handleAddProducts"
    >
      <PlusIcon class="h-5 w-5 text-[#344054]"></PlusIcon>
      <UITextSmMedium class="pl-[8px] !font-[600] text-[#344054]">{{
        t("common.payment.product.addProducts")
      }}</UITextSmMedium>
    </UIButton>
  </div>
  <LayoutOnePreview v-if="store.payment.layout === 1"></LayoutOnePreview>
  <LayoutMultiplePreview v-else></LayoutMultiplePreview>
</template>

<script setup lang="ts">
import { useAppStore } from "@/store/app";
import { ProductIcon } from "@/util/constants";
import { PlusIcon } from "@gohighlevel/ghl-icons/24/outline";
import { UIButton, UISpin, UITextSmMedium } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";
import LayoutMultiplePreview from "./LayoutMultiplePreview.vue";
import LayoutOnePreview from "./LayoutOnePreview.vue";

const store = useAppStore();
const { t } = useI18n();

const emit = defineEmits(["open-settings"]);

const handleAddProducts = () => {
  store.showAddProductSettings = true;
  emit("open-settings");
};
</script>

<style scoped>
.product-container {
  display: flex;
  padding: 32px 8px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 6px;
  border: 1px solid #d0d5dd;
}

.product-icon {
  width: 136px;
  height: 102px;
  flex-shrink: 0;
}
.noproduct-text-container {
  display: flex;
  padding: 0px 16px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}
</style>
